export default {"src":"/_next/static/media/icon-favorite-variant.3326cd54.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};